import DateUtils from "src/services/utils/DateUtils";
import { INTERNATIONAL_DATE_FORMAT } from "src/common/constants";

const dateUtils = new DateUtils();

export const formatPdfDate = (value) => {
    if (value === null || value === undefined || value === "") {
        return "-";
    }
    return dateUtils.convertDateToDate(value, INTERNATIONAL_DATE_FORMAT);
};

export const formatPdfMoney = (amount, currency = "EUR") => {
    if (amount === null || amount === undefined || amount === "") {
        return "-";
    }

    const num = Number(amount);
    if (Number.isNaN(num)) {
        return String(amount);
    }

    try {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency || "EUR",
            maximumFractionDigits: 2,
        }).format(num);
    } catch (e) {
        return `${num} ${currency || ""}`.trim();
    }
};

export const formatPdfYesNo = (value) => {
    if (value === true) {
        return "Yes";
    }
    if (value === false) {
        return "No";
    }
    return "-";
};

export const formatPdfYesNoUnknown = (value) => {
    if (value === true) {
        return "Yes";
    }
    if (value === false) {
        return "No";
    }
    return "Unknown";
};

export const formatPdfDisplay = (value, fallback = "-") => {
    if (value === null || value === undefined || value === "") {
        return fallback;
    }
    return String(value);
};

export const resolveKeyValueColumnLabels = (title = "") => {
    const normalized = String(title).toLowerCase();

    if (normalized.includes("address")) {
        return { titleColumnLabel: "Field", detailsColumnLabel: "Address" };
    }

    if (
        normalized.includes("financial")
        || normalized.includes("ratio")
        || normalized.includes("payment")
        || normalized.includes("workforce")
        || normalized.includes("credit")
    ) {
        return { titleColumnLabel: "Metric", detailsColumnLabel: "Value" };
    }

    if (normalized.includes("contact")) {
        return { titleColumnLabel: "Contact", detailsColumnLabel: "Details" };
    }

    if (normalized.includes("shareholder")) {
        return { titleColumnLabel: "Shareholder", detailsColumnLabel: "Information" };
    }

    if (normalized.includes("activity")) {
        return { titleColumnLabel: "Code", detailsColumnLabel: "Description" };
    }

    if (normalized.includes("event")) {
        return { titleColumnLabel: "Event", detailsColumnLabel: "Information" };
    }

    if (normalized.includes("metadata") || normalized.includes("statement")) {
        return { titleColumnLabel: "Field", detailsColumnLabel: "Value" };
    }

    return { titleColumnLabel: "Title", detailsColumnLabel: "Information" };
};

export const keyValueSection = (title, rows, columnLabels = {}) => {
    const safeRows = (rows || []).filter(Boolean);
    if (!safeRows.length) {
        return null;
    }
    return {
        type: "keyValue",
        title,
        rows: safeRows,
        ...resolveKeyValueColumnLabels(title),
        ...columnLabels,
    };
};

export const recordsSection = (title, columns, records) => {
    const safeRecords = Array.isArray(records) ? records : [];
    if (!safeRecords.length) {
        return null;
    }
    return { type: "records", title, columns, records: safeRecords };
};

export const buildReportHeaderSection = (header) => {
    if (!header || typeof header !== "object") {
        return null;
    }

    return keyValueSection(header.reportName || "Report Details", [
        {
            title: "Report Status Date",
            details: header.createdDate ? formatPdfDate(header.createdDate) : "--",
        },
        {
            title: "Dataset Details",
            details: header.apiName || "--",
        },
    ]);
};

export const formatI18nLabel = (value) => {
    if (!value) {
        return "-";
    }
    if (typeof value === "string") {
        return value;
    }
    return value.en || value.de || value.long || value.short || value.label || "-";
};
